import Product from './Product';
import ProductFactory from './ProductFactory';
import DomainRegistry from '@/creditflowresearch/domain/DomainRegistry';

DomainRegistry.register(async (container, data) => {
  if (data?.products?.length) {
    Product.initialize(data.products, ProductFactory.createFromData);
  }
});

export { default } from './Product';
export { default as Product } from './Product';
export { default as ProductFactory } from './ProductFactory';
export { default as AbsProduct } from './entities/AbsProduct';
export { default as CorporateProduct } from './entities/CorporateProduct';
export { default as HycProduct } from './entities/HycProduct';
export { default as IgcProduct } from './entities/IgcProduct';
export { default as LmProduct } from './entities/LmProduct';

export { ProductType, ProductAbbreviations } from './types/ProductType';
export { ProductRouteType } from './types/ProductRouteType';
